<script setup>
const {search} = useLocationData();
const {locationSearchData} = useLocationSearchSettings();
const route = useRoute();
const {setPageHead} = useGlobalFeaturesData();
const searchText = ref(route.query.s ? route.query.s : '');
const page = ref(route.query.p ? parseInt(route.query.p) : 1);
const locations = ref([]);


const {data: results, error} = await search(searchText, page.value);
locations.value = results.value ? results.value.data : [];
const meta = results.value ? results.value.meta : null;

// TODO Add this object to the server cache
const {data: locationSearchSettings} = await locationSearchData();
definePageMeta({
  layout: "page",
});

const displayJumpToTop = locationSearchSettings.value.jumpToTop;
const customHeroHeader = (locationSearchSettings.value && !!locationSearchSettings.value.heroHeader)? locationSearchSettings.value.heroHeader : null;
const overrideHeroHeader = customHeroHeader !== null;
const displayHeroHeader = locationSearchSettings.value.displayHero;
// Show/hide Ribbon Form
const showBrochureRibbon = locationSearchSettings.value ? locationSearchSettings.value.brochureRibbon : null;
const brochureRibbonTags = locationSearchSettings.value ? locationSearchSettings.value.brochureRibbonTags : [];

// Set meta tags in head for SEO
if(locationSearchSettings.value && locationSearchSettings.value.seo) {
  setPageHead(locationSearchSettings.value.seo, route.path);
}
</script>

<template>
  <LayoutHeroHeader v-if="!overrideHeroHeader && displayHeroHeader" />
  <LayoutHeroHeader :heroHeader="customHeroHeader" v-if="overrideHeroHeader && displayHeroHeader" />
  <LocationSearchResults :searchTerm="searchText" :page="page" :metaData="meta" :locations="locations" :settings="locationSearchSettings" />
  <LayoutRibbonForm v-if="showBrochureRibbon" :ribbonTags="brochureRibbonTags" />
  <LayoutBackToTop v-if="displayJumpToTop"/>
</template>

